import React from 'react';
import NumberField from './NumberField';

export default function CompactNumberField({
  style,
  ...rest
}) {
  return (
    <NumberField
      {...rest}
      style={{
        width: '72px',
        minWidth: '72px',
        marginBottom: 0,
        padding: '4px',
        fontSize: '0.8rem',
        textAlign: 'center',
        ...style,
      }}
    />
  );
}
